import MonitorWebdox from '../firmaContrato/monitor/MonitorWebdox';

const Index = () => {
    return (
        <div>
            {(localStorage.getItem('id_perfil') === '6') && <MonitorWebdox />}
        </div>
    );
}

export default Index;
